module.exports = __webpack_public_path__ + "img/shenbao.c48333f8.png";